export default __webpack_public_path__ + "static/media/D1656_Cava_dei_Tirreni.24fe8777.jpg";